
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import Qrcode from '@xt/www/components/showQrcode/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { EnumAgreementType, EnumAboutUsType } from '@xt/client/enums/home/index'
import { dataSource_AboutUsEntry } from '@xt/client/dataSource/home/index'

@Component({
  components: {
    Qrcode,
    LazyImg
  }
})
export default class extends Vue {
  @Prop() dataSource

  get dataSource_AboutUsEntry() {
    return dataSource_AboutUsEntry
  }

  get EnumAgreementType() {
    return EnumAgreementType
  }

  handleAbout(key: EnumAboutUsType) {
    switch (key) {
      case EnumAboutUsType.Classroom:
        window.open('/about-xuantong')
        break
      case EnumAboutUsType.Wenfang:
        window.open('/stationery')
        break
      case EnumAboutUsType.Art:
        break
      case EnumAboutUsType.World:
        break
      default:
        break
    }
  }

  icp() {
    window.open('https://beian.miit.gov.cn/')
  }

  publics() {
    window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502044839')
  }

  protocol(type) {
    let jumpStr = ''
    if (type === EnumAgreementType.USER) {
      jumpStr = '/protocol/service'
    } else if (type === EnumAgreementType.PROVACY) {
      jumpStr = '/protocol/privacy'
    } else if (type === EnumAgreementType.Contact) {
      jumpStr = '/protocol/contact'
    } else if (type === EnumAgreementType.Feedback) {
      jumpStr = '/protocol/feedback'
    }
    window.open(jumpStr)
  }
  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
